import { useMemo } from 'react';
import { usePersonInfo } from '@/data/Content/PersonInfo';
import { CompleteDataDialogShell } from '@/components/blocks/CompleteDataDialog/CompleteDataDialogShell';
import { CompleteDataForm } from '@/components/blocks/CompleteDataDialog/CompleteDataForm';
import { useLockBodyScroll } from '@/utils/useLockBodyScroll';

const noop = () => undefined;

export const CompleteDataDialogContent = () => {
	const { personInfo, savePersonInfo, mutatePersonInfo, isLoading, open } = usePersonInfo();

	const needsPhoneNumber = useMemo(
		() => !isLoading && Boolean(personInfo.email1) && !personInfo.phone1,
		[isLoading, personInfo.email1, personInfo.phone1]
	);

	useLockBodyScroll(needsPhoneNumber);

	if (!needsPhoneNumber) return null;

	return (
		<CompleteDataDialogShell
			open
			title="COMPLETA TUS DATOS"
			description="Para continuar y ofrecerte las mejores recomendaciones, promociones y productos ideales para ti."
			hideCloseButton
			onClose={noop}
		>
			<CompleteDataForm
				personInfo={personInfo}
				saving={open}
				onSubmit={savePersonInfo}
				onSaved={mutatePersonInfo}
			/>
		</CompleteDataDialogShell>
	);
};
